module.exports = __webpack_public_path__ + "static/media/Omastar_gaussian2.c63ea14b.png";